/**
 * Openpayd Service
 */
export class OpenpaydService {

    constructor(accessToken) {
        this.API_URL = process.env.REACT_APP_API_URL;
        this.accessToken = accessToken;
    }

    async getAllOpenpayd(pageSize, pageNum, currency){
        const response = await fetch(
            this.API_URL + `/openpayd?size=${pageSize}&page=${pageNum}${currency ? '&currency=' + currency : ''}`,
            {
                headers: {
                    // 'Content-Type': 'application/json'
                    Authorization: `Bearer ${this.accessToken}`
                }
            }
        );
        return response.json();
    }

    async setOpenpaydClient(openpaydTxId, clientCopperID) {
        const response = await fetch(
            this.API_URL + '/openpayd/setclient',
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${this.accessToken}`
                },
                body: JSON.stringify({
                    openpaydTxId,
                    clientCopperID
                })
            }
        );
        return response.json();
    }

}